<div class="document-number-info">
  <span class="document-type" [hidden]="!documentType">
    {{ 'DOCUMENT.TYPE.' + documentType | uppercase | translate }}
  </span>

  <span class="document-number">
    {{ 'LABEL.DOCUMENT_NUMBER_SYMBOL' | translate }}{{ documentNumber }}
  </span>
</div>
